import React from "react";
import { Box } from "rebass";

interface IProps {
  value: number;
}

const HEIGHT = 7;

export const Progress: React.FC<IProps> = ({ value }) => (
  <Box
    width={1}
    height={`${HEIGHT}px`}
    bg="#ececec"
    css={`overflow: hidden; border-radius: ${HEIGHT / 2}px;`}
  >
    <Box
      width={`${value}%`}
      height="100%"
      bg="sp-blue"
      css="border-radius: inherit; transition: width .4s;"
    />
  </Box>
);
